<template>
    <v-text-field
        :id="'city' + this._uid"
        autocomplete="false"
        v-model="value.search"
        :rules="[rules.required, cityCheckRule]"
        label="Город"
        validate-on-blur
    ></v-text-field>
</template>

<script>
    import $ from 'jquery';
    import 'suggestions-jquery';
    export default {
        props: {
            model: {
                required: true
            },
            options: {
                type: Object,
                default: () => ({
                    //token: 'd41d36d28500ad106eddbdc20258ec57d945f1d1',
                    token: '14a86f53aaa54b7bb802c4f1b895a59ba2006b30',
                    type: 'ADDRESS',
                    addon: 'spinner',
                    count: 5,
                    minChars: 2,
                    floating: true,
                    bounds: 'city-settlement',
                }),
            },
            short: {
                default: false,
            },
        },

        data: () => ({
            element: null,
            init: false,
            value: '',
            flatTip: false,
            rules: {
                required: v => !!v || 'Обязательное поле',
            },
        }),

        computed: {
            cityCheckRule() {
                return () => !!this.value.city || 'Нужно указать город';
            }
        },

        mounted() {
            this.options.onSelect = suggestion => this.onSelectCity(suggestion);
            this.value = this.model;
            this.element = $('#city'+this._uid);
            this.$nextTick(() => {
                this.initSuggestion();
            });
        },

        destroyed() {
            this.destroySuggestion();
        },

        watch: {
            value() {
                this.$emit('update:model', this.value);
            },
            model() {
                this.value = this.model;
            }
        },

        methods: {
            initSuggestion() {
                if (this.init) {
                    return;
                }
                const plugin = this.element.suggestions(this.options);
                if (this.value.search) {
                    const cityFias = this.value.city_fias;

                    const data = {
                        query: cityFias,
                        count: 3,
                        locations_boost: [{
                            "fias_id": cityFias
                        }]
                    };
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Token ' + this.options.token
                    };
                    axios.post(
                        plugin.suggestions().options.serviceUrl + '/suggest/address',
                        data,
                        {headers: headers}
                    ).then(response => {
                        if (response && response.data && response.data.suggestions && response.data.suggestions.length) {
                            this.onSelectCity(response.data.suggestions[0]);
                        } else {
                            console.log(response);
                        }
                    }).catch(error => {
                        console.log(error)
                    });
                }

                this.init = true;
            },
            destroySuggestion() {
                this.element.suggestions().dispose();
            },
            onSelectCity(suggestion) {
                this.value.city = this.value.search = suggestion.value;
                this.value.city_kladr = suggestion.data.city_kladr_id ? suggestion.data.city_kladr_id : suggestion.data.settlement_kladr_id;
                this.value.city_fias = suggestion.data.city_fias_id ? suggestion.data.city_fias_id : suggestion.data.settlement_fias_id;
            },
        }
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/fields/CityDadata.vue